<template>
  <div id="principal-login container" style="width: 100vw;">
    <div class="principal">
      <nav class="navbar nav-masters">
        <a class="navbar-brand mx-auto">
          <img src="../../../../public/img/images/logo-emb.png" class="logo-embajadores" />
        </a>
      </nav>
    </div>
    <div class="div-login">
      <div class="contenedor-login">
        <p class="ingresa">
          {{ this.idioma == "ES" ? "Ingresa" : "Sign in" }}
        </p>
        <form v-on:submit.prevent="iniciarSesionMaster">
          <input @keypress="ControlarCampoUsuario" type="email"
            :placeholder="this.idioma == 'ES' ? 'Correo electrónico' : 'Email'" class="form-control input-login"
            v-model="correo" name="username" required />
          <div class="inner-addon right-addon">
            <i class="fas fa-eye-slash icono-pass" style="cursor: pointer !important;" v-if="mostrandoContrasena == false"
              @click="Mostrar" />
            <i class="far fa-eye icono-pass" style="cursor: pointer !important;" v-if="mostrandoContrasena == true"
              @click="Mostrar" />
            <input :type="tipoCampo" maxlength="12" v-model="contrasena" class="form-control input-login" name="password"
              :placeholder="this.idioma == 'ES' ? 'Contraseña' : 'Password'" required />
          </div>
          <button disabled type="submit" id="sendlogin" class="btn btn-block btn-login w-100" v-if="iniciandoSesion">
            <v-progress-circular indeterminate size="30" color="white"></v-progress-circular>
          </button>
          <button type="submit" id="sendlogin" class="btn btn-block btn-login w-100" v-else>
            {{ this.idioma == "ES" ? "Iniciar sesión" : "Login" }}
          </button>
          <div class="row">
            <div class="col-md-4 col-sm-4 etiqueta-idioma">
              <a class="etiqueta-olvide-contraseña" @click.prevent="CambiaIdioma('EN')">
                {{ this.idioma == "ES" ? "Ingles /" : "English /" }}
              </a>
              <a class="etiqueta-olvide-contraseña" @click.prevent="CambiaIdioma('ES')">
                {{ this.idioma == "ES" ? " Español" : " Spanish" }}
              </a>
            </div>
            <div class="col-md-8 col-sm-8 etiqueta-contrasena-olvidada">
              <a v-if="this.idioma == 'ES'" class="etiqueta-olvide-contraseña"
                @click.prevent="RecuperarContrasenia('ES')">
                "¿Olvidaste tu contraseña?"
              </a>
              <a v-else class="etiqueta-olvide-contraseña" @click.prevent="RecuperarContrasenia('EN')">
                "Reset password"
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const rutaValidarTipo = "api/Master/Prospecto/ValidarTipoUsuario";
import axios from "axios";

export default {
  name: "loginMaster",
  data() {
    return {
      idioma: "ES",
      correo: "",
      contrasena: "",
      mensaje: "asd",
      token: "",
      mostrandoContrasena: false,
      tipoCampo: "password",
      iniciandoSesion: false,
      primerAcceso: false,
      preonboarding: false
    };
  },
  mounted() {
    this.$store.commit("setModoPago", null);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const qrEng = urlParams.get("isforeign") != null ? urlParams.get("isforeign") : 'false';
    if (queryString.includes("paymentMethod")) {
      this.$store.commit(
        "setModoPago",
        parseInt(urlParams.get("paymentMethod"))
      );
    } else {
      this.$store.commit("setModoPago", 1);
    }

    if(qrEng == 'true') {
      this.idioma = 'EN';
    } else {
      if (queryString.includes("idioma")) {
        this.idioma = urlParams.get("idioma");
      }
    }
    /** 
     *  Ajuste 14/sep/2023 | Incode_popup_qr_preonboarding  :
     *  Ajuste en qr y preonboarding asi como query para redireccionamieto
     * */
    if ('preonboarding' in this.$route.query) {
      this.preonboarding = this.$route.query.preonboarding === 'true';
      sessionStorage.setItem("preonboarding", this.preonboarding);
    }

  },
  methods: {
    ControlarCampoUsuario: function (event) {
      if (event.charCode == 32) {
        event.preventDefault();
      }
    },
    Mostrar() {
      if (this.mostrandoContrasena == false) {
        this.tipoCampo = "text";
        this.mostrandoContrasena = true;
      } else {
        this.tipoCampo = "password";
        this.mostrandoContrasena = false;
      }
    },
    CambiaIdioma(lang) {
      this.idioma = lang;
      this.$forceUpdate();
    },
    RecuperarContrasenia(lang) {
      console.log(lang);
      this.$router.push({
        name: "ReestablecerContrasenia"
      });
    },
    iniciarSesionMaster: function () {
      this.iniciandoSesion = true;
      axios
        .post("api/Identity/Login", {
          usuario: this.correo,
          contrasenia: this.contrasena
        })
        .then(resp => {
          if (resp.data.estado === 0) {
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + resp.data.data;
            //Guardar el token en la sesión
            sessionStorage.setItem("Token", "Bearer " + resp.data.data);
            this.iniciandoSesion = false;
            this.verificarTipoUsuario();
          } else if (resp.data.estado === 1) {
            this.iniciandoSesion = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.iniciandoSesion = false;
          this.ManejarExcepcion(e);
        });
    },
    verificarTipoUsuario() {
      axios
        .get(rutaValidarTipo)
        .then(resp => {          
          if (resp.data.estado === 0) {
            let tipoUsuario = resp.data.data.usuarioActual;
            let nombreUsuario = resp.data.data.nombreUsuario;
            let apellidoUsuario = resp.data.data.apellidoUsuario;
            let etapaId = resp.data.data.etapaProspecto;
            let usuarioId = resp.data.data.usuarioId;
            sessionStorage.setItem("zona", resp.data.data.zona);
            this.$store.commit("zona", resp.data.data.zona);
            sessionStorage.setItem("tipoPersona", resp.data.data.tipoPersona);
            this.$store.commit("setTipoPersona", resp.data.data.tipoPersona);
            this.$store.commit("setUsuario", resp.data.data.usuarioId);
            this.$store.commit("setSesionActiva", true);
            if (tipoUsuario == 0 || tipoUsuario == 2) {
              this.AlertaEmbajadores(
                this.idioma == "ES" ?
                  "El usuario no ha sido activado, por favor verifique su correo electrónico para activarlo."
                  : "The user has not been activated, please check your email to activate it.",
                true
              );
            } else {
              if (tipoUsuario == 3) {
                sessionStorage.setItem("zona", resp.data.data.zona);
                this.$store.commit("zona", resp.data.data.zona);
                this.$store.commit("setProspecto", resp.data.data.prospectoId);
                this.$store.commit(
                  "setTipoPersona",
                  resp.data.data.tipoPersona
                );
                sessionStorage.setItem(
                  "primerAcceso",
                  resp.data.data.primerAcceso);
                this.primerAcceso = sessionStorage.getItem("primerAcceso") == "true" ? true : false;
                if (this.primerAcceso) {
                  this.$store.commit("setAvisoPrivacidadAceptado", false);
                }
                else {
                  this.$store.commit("setAvisoPrivacidadAceptado", true);
                }
              } else {
                this.$store.commit("setMasterId", resp.data.data.masterId);
              }
              sessionStorage.setItem("tipoUsuario", tipoUsuario);
              sessionStorage.setItem("etapaId", etapaId);
              sessionStorage.setItem("nombreUsuario", nombreUsuario);
              sessionStorage.setItem("apellidoUsuario", apellidoUsuario);
              sessionStorage.setItem("usuarioId", usuarioId);
              this.$store.commit("setTipoUsuario", tipoUsuario);
              this.$store.commit("setEtapaId", etapaId);
              this.$router.push({ name: "Home" });
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/estilos/estilosgenerales.scss";

.nav-masters {
  background-color: #ffffff;
  border-style: none;
}

.principal {
  text-align: center;
  padding-bottom: 6px;
  background: linear-gradient(90deg,
      #9e6353 0%,
      #a16555 22.05%,
      #a86d5b 31.23%,
      #b57a65 38.02%,
      #ca9076 43.63%,
      #e6ad8d 48.46%,
      #f6be9a 50.49%,
      #eeb590 51.88%,
      #dea47d 55.64%,
      #d39770 60.13%,
      #cd9168 65.98%,
      #cb8f66 78.29%,
      #9e6353 100%);
  background-size: 100% 5px;
}

.logo-embajadores {
  cursor: pointer;
  height: 80px;
  width: 180px;
  margin-right: 25px;
}

.div-login {
  background: url("../../../../public/img/images/ciudad2.png") no-repeat center center fixed;
  background-size: cover;
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contenedor-login {
  width: 20vw;
}

.ingresa {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 44px;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0.05em;
}

.input-login {
  margin-top: 10px;
  height: 50px;
  border-radius: 0px;
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  color: rgba(30, 33, 32, 0.55);
  border-style: none;
}

.form-control:focus {
  color: #495057;
  background-color: #ffffff;
  border-color: #ffffff;
  outline: none;
  box-shadow: none;
}

.etiqueta-olvide-contraseña {
  color: $color-primario;
  font-size: 12px;
  font-family: $poppins;
  cursor: pointer;
  text-decoration: underline;
}

.form-check {
  position: relative;
  display: block;
  margin-left: -20px;
  margin-bottom: 10px;
}

.btn-login {
  margin-top: 10px;
  border: 1px solid $color-primario;
  border-radius: 0px;
  height: 50px;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
  background-color: $color-primario;
  font-family: $poppins;
}

/**Estilos checkbox */
.containerchbx {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.containerchbx input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 17px;
  width: 17px;
  background-color: #eee;
}

.container:hover input~.checkmark {
  background-color: rgba(211, 117, 16, 0.15);
}

.container input:checked~.checkmark {
  background-color: #eb8113;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked~.checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 8px;
  top: 3.5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/*VER/OCULTAR Contraseña*/
.inner-addon {
  position: relative;
}

.icono-pass {
  color: $color-primario;
}

.inner-addon .icono-pass {
  position: absolute;
  padding: 17px;
  margin-left: -30px;
}

/* align glyph */
.left-addon .icono-pass {
  left: 0px;
}

.right-addon .icono-pass {
  right: 0px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}

.right-addon input {
  padding-right: 30px;
}

.etiqueta-contrasena-olvidada {
  text-align: end;
}

.etiqueta-idioma {
  text-align: start;
}

/* TABLETAS */
@media all and (min-width: 768px) and (max-width: 1024px) {
  .contenedor-login {
    margin-top: -45%;
    width: 50vw;
  }

  .etiqueta-contrasena-olvidada {
    text-align: center;
  }

  .etiqueta-idioma {
    text-align: center;
  }

  .ingresa {
    font-size: 28px;
  }
}

/* CELULARES */
@media all and (max-width: 767px) {
  .contenedor-login {
    margin-top: -45%;
    width: 75vw;
  }

  .logo-embajadores {
    cursor: pointer;
    height: 65px;
    width: 140px;
    margin-left: 10px;
  }

  .etiqueta-contrasena-olvidada {
    text-align: center;
  }

  .etiqueta-idioma {
    text-align: center;
  }

  .ingresa {
    font-size: 26px;
  }

  .btn-login,
  .input-login {
    height: 45px;
  }
}
</style>
